import React from 'react'
import {LangSelect} from "../../../../../i18n";
import {isRtl} from "../../../../../locales";
import {isMobile} from "react-device-detect";

const HeaderTopbar = ({context}) => {
    const {org,config}=context

    return(
        <div className="topbar">
            <div className="container">
                <div className="row">
                    <div className="col col-md-8 col-sm-12 col-12">
                        <div className="contact-intro">
                            <ul style={{display:"flex",alignItems:"center"}}>
                                {!context.isMobile &&(
                                    <div style={{display:"flex",alignItems:"center",justifyContent:"center",paddingLeft:isRtl(context?.langValue)?20:0,paddingRight:isRtl(context?.langValue)?0:20}}>
                                        <LangSelect light context={context}/>
                                    </div>
                                )}
                                <li><i className="fi flaticon-call"></i><a style={{color:"#666"}} href={"tel:"+org.contact.tel}> {org.contact.tel}</a></li>
                                <li><i className="fi flaticon-envelope"></i><a style={{color:"#666"}} href={"mailto:"+org.contact.email}> {org.contact.email}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col col-md-4 col-sm-12 col-12">
                        <div className="contact-info">
                            <ul style={{display:"flex",alignItems:"center",float:context.isMobile?"none":"inline-end"}}>
                                {config["social.whatsapp"] && (
                                    <li><a href={config["social.whatsapp"]}><img src={"/icons/whatsapp.png"} style={{width:20,}}/></a></li>
                                )}

                                {config["social.yt"] && (
                                    <li><a href={config["social.yt"]}><img src={"/icons/youtube.png"} style={{width:20,marginTop:3}}/></a></li>
                                )}

                                {config["social.fb"] && (
                                    <li><a href={config["social.fb"]}><img src={"/icons/facebook.png"} style={{width:20,}}/></a></li>
                                )}

                                {config["social.insta"] && (
                                    <li><a href={config["social.insta"]}><img src={"/icons/instagram.png"} style={{width:18,}}/></a></li>
                                )}

                                {config["social.tiktok"] && (
                                    <li><a href={config["social.tiktok"]}><img src={"/icons/tiktok.png"} style={{width:18,}}/></a></li>
                                )}
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopbar;
